export function isOwner(role) {
  return role === 'owner';
}

export function isAdminOrOwner(role) {
  return role === 'admin' || role === 'owner';
}

export function isManagerOrAbove(role) {
  return role === 'manager' || role === 'admin' || role === 'owner';
}

export function canManageAdminUsers(role) {
  return role === 'owner';
}

export function canEditTargetUser(actorRole, actorId, targetUser) {
  if (!targetUser) return false;
  if (targetUser.role === 'owner') {
    return targetUser.id === actorId && actorRole === 'owner';
  }
  if (actorRole === 'owner') return true;
  if (actorRole === 'admin') {
    if (targetUser.id === actorId) return true;
    return targetUser.role !== 'admin';
  }
  if (actorRole === 'manager') {
    return targetUser.role === 'cashier' || targetUser.id === actorId;
  }
  return false;
}

export function canDeleteTargetUser(actorRole, actorId, targetUser) {
  if (!targetUser || targetUser.id === actorId) return false;
  if (targetUser.role === 'owner') return false;
  if (actorRole === 'owner') return true;
  if (actorRole === 'admin') return targetUser.role !== 'admin';
  if (actorRole === 'manager') return targetUser.role === 'cashier';
  return false;
}

export function canToggleTargetUserStatus(actorRole, actorId, targetUser) {
  if (!targetUser || targetUser.id === actorId) return false;
  if (targetUser.role === 'owner') return false;
  return canEditTargetUser(actorRole, actorId, targetUser);
}

export function canAssignRole(actorRole, role) {
  if (role === 'owner') return false;
  if (actorRole === 'owner') return role !== 'owner';
  if (actorRole === 'admin') return role === 'cashier' || role === 'manager';
  if (actorRole === 'manager') return role === 'cashier';
  return false;
}

export function isUserVisibleInList(actorRole, actorId, targetUser) {
  if (!targetUser) return false;
  if (actorRole === 'owner') return true;
  if (targetUser.id === actorId) return true;
  if (actorRole === 'admin') {
    return targetUser.role === 'cashier' || targetUser.role === 'manager';
  }
  if (actorRole === 'manager') {
    return targetUser.role === 'cashier';
  }
  return false;
}
